import { render, staticRenderFns } from "./CalculatorComponent.vue?vue&type=template&id=2b00178c&lang=pug&"
import script from "./CalculatorComponent.vue?vue&type=script&lang=ts&"
export * from "./CalculatorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports